import React, { useEffect, useState } from "react"
import Dropzone from "react-dropzone"
import MetaTags from "react-meta-tags"
import Select from "react-select"
import {
    Card, CardBody, Col,
    Container, Input, Label, Row
} from "reactstrap"

// Form Editor
import ReactQuil from "react-quill"
import "react-quill/dist/quill.snow.css"
import { useParams } from "react-router-dom"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import CourseCurriculum from "components/CourseComponent/Curriculum"
import { withTranslation } from "react-i18next"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

const AddNewCourse = props => {
  const [getCourseDetails, setGetCourseDetails] = useState(null)
  const [addStatus, setAddStatus] = useState(false)

  /**
   * * State for course data
   */
  const [title, setTitle] = useState("")
  const [fakeStudentEnrolled, setFakeStudentEnrolled] = useState(0)
  const [regularPrice, setRegularPrice] = useState(0)
  const [salePrice, setSalePrice] = useState(0)
  const [instructor, setInstructor] = useState("")
  const [thumbnailImage, setThumbnailImage] = useState([])
  const [details, setDetails] = useState(null)
  const [allCategories, setAllCategories] = useState([])
  const [categories, setCategories] = useState([])
  const [categoryOption, setCategoryOption] = useState([])

  const [finalCategory, setFinalCategory] = useState([])

  const { id } = useParams()

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/course/get/${id}`, {
      method: "GET",
    })
      .then(res => res.json())
      .then(data => setGetCourseDetails(data?.message))
      .catch(err => console.log(err))
    setAddStatus(false)
  }, [id, addStatus])

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/course/category/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then(res => res.json())
      .then(data => setAllCategories(data?.message))
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    allCategories?.length > 0 &&
      allCategories?.map(category =>
        setCategoryOption(prevCategory => [
          ...prevCategory,
          { label: category?.category_name, value: category?._id },
        ])
      )
  }, [allCategories])

  useEffect(() => {
    categories?.length > 0 &&
      categories?.map(category => {
        setFinalCategory(prevCategory => [...prevCategory, category?.value])
      })
  }, [categories])

  const categoryNames = [
    {
      options: categoryOption,
    },
  ]

  useEffect(() => {
    setTitle(getCourseDetails !== null ? getCourseDetails?.title : "")
    setFakeStudentEnrolled(
      getCourseDetails !== null ? getCourseDetails?.enrollement_count : ""
    )
    setRegularPrice(
      getCourseDetails !== null ? getCourseDetails?.regular_price : ""
    )
    setSalePrice(getCourseDetails !== null ? getCourseDetails?.sale_price : "")
    setDetails(
      getCourseDetails !== null
        ? getCourseDetails?.course_description !== null
          ? getCourseDetails?.course_description
          : ""
        : ""
    )
  }, [getCourseDetails])

  console.log({ getCourseDetails })

  useEffect(() => {
    getCourseDetails?.category?.map(ct => {
      console.log(ct)
      const findCategory = allCategories?.find(c => c?._id === ct)
      console.log(findCategory)
      if (findCategory !== undefined) {
        setCategories(prevCategory => [
          ...prevCategory,
          { label: findCategory?.category_name, value: findCategory?._id },
        ])
      }
    })
  }, [getCourseDetails, allCategories])

  console.log({ finalCategory })

  const optionGroup = [
    {
      options: [
        { label: "Syket", value: "Syket" },
        { label: "Pranto", value: "Pranto" },
        { label: "Zabir", value: "Zabir" },
        { label: "Rasel", value: "Rasel" },
      ],
    },
  ]

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setThumbnailImage(files)
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const handleUpdate = async () => {
    const body = {
      title,
      course_description: details,
      catagory: "Programming",
      subject: "Language",
      category: [...new Set(finalCategory)],
      regular_price: Number(regularPrice),
      sale_price: Number(salePrice),
      enrollement_count: Number(fakeStudentEnrolled),
      tag: ["C", "programming"],
      upload_featured_image: "www.kerkjcndkekn",
    }

    await fetch(`${process.env.REACT_APP_URL}/api/course/update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(res => res?.json())
      .then(data => {
        toastr.success(data?.message, "Course")
      })
      .catch(err => console.log(err))
  }
  const handleBodyChange = e => {
    setDetails(e)
  }

  function handleMulti(e) {
    setCategories(e)
    setFinalCategory([])
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Qlearn </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Courses")}
            breadcrumbItem={props.t("Add new course")}
          />

          <Row>
            <Col xl="12">
              <Row>
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardBody>
                        <div>
                          <div className="mb-3">
                            <Label htmlFor="formrow-firstname-Input">
                              Title
                            </Label>
                            <Input
                              value={title}
                              onChange={e => setTitle(e.target.value)}
                              type="text"
                              className="form-control"
                              id="formrow-firstname-Input"
                              placeholder="Course Title"
                            />
                          </div>

                          <Row>
                            <Col
                              lg={12}
                              style={{ marginTop: "0px", marginBottom: "10px" }}
                            >
                              <ReactQuil
                                modules={AddNewCourse.modules}
                                formats={AddNewCourse.formats}
                                value={details}
                                onChange={e => handleBodyChange(e)}
                                placeholder="Write something amazing..."
                              />
                            </Col>
                          </Row>
                          <Row>
                            <CourseCurriculum
                              setAddStatus={setAddStatus}
                              addStatus={addStatus}
                              chapters={getCourseDetails?.chapter}
                              id={getCourseDetails?._id}
                            />
                          </Row>

                          <div className="mb-3">
                            <Label htmlFor="formrow-firstname-Input">
                              Fake Student Enrolled
                            </Label>
                            <Input
                              value={fakeStudentEnrolled}
                              onChange={e =>
                                setFakeStudentEnrolled(e.target.value)
                              }
                              type="number"
                              className="form-control"
                              id="formrow-firstname-Input"
                              placeholder="0"
                            />
                          </div>
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-email-Input">
                                  Regular Price
                                </Label>
                                <Input
                                  value={regularPrice}
                                  onChange={e =>
                                    setRegularPrice(e.target.value)
                                  }
                                  type="number"
                                  className="form-control"
                                  id="formrow-email-Input"
                                  placeholder="0"
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-password-Input">
                                  Sale Price
                                </Label>
                                <Input
                                  value={salePrice}
                                  onChange={e => setSalePrice(e.target.value)}
                                  type="number"
                                  className="form-control"
                                  id="formrow-password-Input"
                                  placeholder="0"
                                />
                              </div>
                            </Col>
                          </Row>

                          <div className="mb-3">
                            <Label>Instructors</Label>
                            <Select
                              value={instructor}
                              onChange={data => {
                                setInstructor(data)
                              }}
                              options={optionGroup}
                              classNamePrefix="select2-selection"
                            />
                          </div>

                          <div className="mb-3">
                            <label className="control-label">
                              Select Categories
                            </label>
                            <Select
                              value={categories}
                              isMulti={true}
                              onChange={e => {
                                handleMulti(e)
                              }}
                              options={categoryNames}
                              classNamePrefix="select2-selection"
                            />
                          </div>

                          <div>
                            <label htmlFor="">Upload Featured Image</label>
                            <Dropzone
                              onDrop={acceptedFiles => {
                                handleAcceptedFiles(acceptedFiles)
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone">
                                  <div
                                    className="dz-message needsclick mt-2"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                      <i className="display-4 text-muted bx bxs-cloud-upload" />
                                    </div>
                                    <h4>Drop files here or click to upload.</h4>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            <div
                              className="dropzone-previews mt-3"
                              id="file-previews"
                            >
                              {thumbnailImage.map((f, i) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <span className="text-muted font-weight-bold">
                                            {f.name}
                                          </span>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                )
                              })}
                            </div>
                          </div>

                          <div>
                            <button
                              onClick={handleUpdate}
                              className="btn btn-primary w-md"
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewCourse.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { header: [3, 4, 5, 6] }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    ["clean"],
    ["code-block"],
  ],
}

AddNewCourse.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "link",
  "image",
  "video",
  "code-block",
]

export default withTranslation()(AddNewCourse)
